import "../css/app.css";

// Toggling the "is-active" class on both the "navbar-burger" and the "navbar-menu"
// based on Bulma's standard implementation: https://bulma.io/documentation/components/navbar/#navbar-menu
function toggleNavbar() {
  const burgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0);

  burgers.forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const target = el.dataset.target;
      const $target = document.getElementById(target);

      if ($target) {
        el.classList.toggle('is-active');
        $target.classList.toggle('is-active');

        // Toggle aria-expanded for accessibility
        const isActive = el.classList.contains('is-active');
        el.setAttribute('aria-expanded', isActive);
      }
    });
  });
}

function handleNotifications() {
  const deletes = Array.prototype.slice.call(document.querySelectorAll('.notification .delete'), 0);

  deletes.forEach(el => {
    const $notification = el.parentNode;
    el.addEventListener('click', () => {
      $notification.parentNode.removeChild($notification);
    });
  });
}

function handleFoodItems() {
  const addButton = document.getElementById('add-food-item');
  const container = document.getElementById('food-items-container');
  const template = document.getElementById('food-item-template');

  if (!addButton || !container || !template) return;

  addButton.addEventListener('click', () => {
    const clone = template.content.cloneNode(true);
    container.appendChild(clone);
  });

  container.addEventListener('click', (e) => {
    if (e.target.closest('.remove-food-item')) {
      const row = e.target.closest('.food-item-row');
      row.parentNode.removeChild(row);
    }
  });
}

let keepAliveInterval;

function keepAlive() {
  const host = document.body.dataset.host;
  const hamFgsHost = document.body.dataset.hamFgsHost;

  const uniquer=`?_=${new Date().getTime()}`;
  if (host && host !== "") {
    fetch(`//${host}/api/v1/ping${uniquer}`);
  }
  if (hamFgsHost && hamFgsHost !== "") {
    fetch(`//${hamFgsHost}/api/v1/ping${uniquer}`);
  }
}

function startKeepAlive() {
  if (keepAliveInterval) return;
  keepAlive(); // Initial ping when starting
  keepAliveInterval = setInterval(keepAlive, 30000);
}

function stopKeepAlive() {
  if (keepAliveInterval) {
    clearInterval(keepAliveInterval);
    keepAliveInterval = null;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  toggleNavbar();
  handleNotifications();
  handleFoodItems();

  // Start pings if page is visible
  if (document.visibilityState === 'visible') {
    startKeepAlive();
  }

  // Handle tab visibility changes
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') {
      startKeepAlive();
    } else {
      stopKeepAlive();
    }
  });
});
